import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Plugin } from 'prosemirror-state';
import { Slice, Fragment } from 'prosemirror-model';
import pluginKey from './pluginKey';
import { isEmpty } from '../../../../utils/helper';
import { isEmbedUrl } from '../../utils/embed';
import { link } from './marks/link';
import { convertToHtmlFromSchema, getDocFromHtml } from '../../utils';
const HTTP_LINK_REGEX = /(https?:\/\/[^\s]+)/g;
const FLOATING_TOOLBAR_ITEMS = [{
  id: 'open-link',
  title: 'Open Link in new tab',
  icon: 'icon-goto',
  onClick: (state, dispatch, view, pluginState) => {
    if (pluginState.attrs.href) {
      let url = pluginState.attrs.href;
      const urlMatch = url.match(HTTP_LINK_REGEX);
      if (isEmpty(urlMatch)) {
        url = 'http://' + url;
      }
      window.open(url);
    }
  }
}];
const linkify = (view, fragment, embedPatterns) => {
  const linkified = [];
  fragment.forEach(child => {
    if (child.isText) {
      const {
        text
      } = child;
      let pos = 0;
      let match;
      do {
        match = HTTP_LINK_REGEX.exec(text);
        if (match) {
          const start = match.index;
          const end = start + match[0].length;
          const {
            link
          } = child.type.schema.marks;
          const {
            embedCard
          } = child.type.schema.nodes;
          if (start > 0) {
            linkified.push(child.cut(pos, start));
          }
          const urlText = text.slice(start, end);
          const {
            canEmbed,
            width,
            height
          } = isEmbedUrl(urlText, embedPatterns);
          if (canEmbed) {
            linkified.push(embedCard.create({
              url: child.cut(start, end).text,
              width: width,
              height: height
            }));
          } else {
            linkified.push(child.cut(start, end).mark(link.create({
              href: urlText
            }).addToSet(child.marks)));
          }
          pos = end;
        }
      } while (match);
      if (pos < text.length) {
        linkified.push(child.cut(pos));
      }
    } else {
      linkified.push(child.copy(linkify(view, child.content, embedPatterns)));
    }
  });
  return Fragment.fromArray(linkified);
};
const handlePastedContent = (view, content, embedPatterns) => {
  const {
    schema
  } = view.state;
  const fragment = linkify(view, content, embedPatterns);
  const sanitizedHtml = convertToHtmlFromSchema(schema, fragment.toJSON());
  const sanitizedDoc = getDocFromHtml(schema, sanitizedHtml);
  const sanitizedJson = sanitizedDoc.toJSON().content;
  const newFragment = Fragment.fromJSON(schema, sanitizedJson);
  return newFragment;
};
export default {
  name: 'link',
  configure: options => ({
    marks: {
      link: link(options)
    },
    plugin: new Plugin({
      key: pluginKey,
      props: {
        transformPasted: (slice, view) => new Slice(handlePastedContent(view, slice.content, options.embedPatterns), slice.openStart, slice.openEnd),
        handleClickOn: (view, pos, node, nodePos, event) => {
          const {
            ctrlKey,
            metaKey,
            target
          } = event;
          var url = target.getAttribute('href');
          url = url && url.trim();
          if (!/^(https?:)?\/\//i.test(url)) {
            url = 'http://' + url;
          }
          const absoluteUrl = url;
          if (absoluteUrl && (ctrlKey || metaKey) && view.editable) {
            window.open(absoluteUrl);
            return true;
          }
          if (absoluteUrl && (ctrlKey || metaKey || !view.editable)) {
            target.setAttribute("target", "_blank");
            return true;
          }
          return false;
        }
      },
      state: {
        init: (_, state) => {
          return {
            pos: null,
            attrs: {}
          };
        },
        apply: (tr, pluginState, _oldState, newState) => {
          if (tr.docChanged || tr.selectionSet) {
            const linkNode = newState.selection.$head.marks().find(mark => mark.type === newState.schema.marks.link);
            const pos = newState.selection.from;
            const newPluginState = _objectSpread(_objectSpread({}, pluginState), {}, {
              pos: linkNode ? pos : null,
              attrs: linkNode ? linkNode.attrs : {}
            });
            return newPluginState;
          }
          return pluginState;
        }
      }
    }),
    floatingToolbars: [{
      pluginKey,
      info: {
        items: FLOATING_TOOLBAR_ITEMS,
        inline: true
      }
    }]
  })
};